module.exports = __webpack_public_path__ + "static/Java-Iphone-4832d62ffa3db24d85c917f6f5f6c0ac.mp4";